import React, { useContext, useEffect, useState } from 'react'

const AccordSlideHeads = (props) => {

    const [sectionHead, setSectionHead] = useState(props.sectionHead);
    const [slideSubTxt, setSlideSubTxt] = useState(props.slideSubTxt);

    useEffect(() => {
        setSectionHead(props.sectionHead);
    }, [props.sectionHead])

    useEffect(() => {
        setSlideSubTxt(props.slideSubTxt);
    }, [props.slideSubTxt])



    return (
        <>
            <div className={"prodFirst"}>
                <label>כותרת הסליידר</label>
                <input type="text" value={sectionHead} placeholder={"כותרת הסליידר"}
                    onBlur={(e) => props.changeSectionHead(props.index, e.target.value)}
                    onChange={(e) => setSectionHead(e.target.value)} />
            </div>
            <div className={"prodFirst"}>
                <label>כותרת משנית סליידר</label>
                <input type="text" value={slideSubTxt} placeholder={"כותרת משנית סליידר"}
                    onBlur={(e) => props.changeSlideSubTxt(props.index, e.target.value)}
                    onChange={(e) => setSlideSubTxt(e.target.value)} />
            </div>
        </>
    )
}

export default AccordSlideHeads;